import script from "./DuaTawaf.vue?vue&type=script&setup=true&lang=js"
export * from "./DuaTawaf.vue?vue&type=script&setup=true&lang=js"

import "./DuaTawaf.vue?vue&type=style&index=0&id=a4b1aace&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4b1aace"]])

export default __exports__